import { ApiLoading } from "components/ApiLoading";
import { Badge } from "components/base/Badge";
import { DataTable } from "components/base/DataTable";
import Section from "components/base/Section"
import { Title } from "components/base/Title";
import { DialogPreparerLivraison } from "components/DialogPreparerLivraison";
import { useEffect, useState } from "react";
import { getLivraisons, Livraison } from "services/apiLivraisons";
import { handleApiError } from "utils/errorHandlers";
import { filtersStatutLivraison, getColorStatutLivraison, getStatutLivraison } from "utils/utils";
import AlertLivraisonMissing from "../../components/AlertLivraisonMissing";

export const SuiviLivraisonReferent = () => {
	const [open, setOpen] = useState<boolean>(false);
	const [livraisons, setLivraisons] = useState<Livraison[]>([]);
	const [selectedLivraisonId, setSelectedLivraisonId] = useState<number | null>(null);
	const [loading, setLoading] = useState<boolean>(true);
	const [errors, setErrors] = useState<Record<string, string[]>>({});

	useEffect(() => {
		const fetchLivraisons = async () => {
			try {
				const data = await getLivraisons();
				setLivraisons(data);
			} catch (error: any) {
				setErrors(handleApiError(error));
			} finally {
				setLoading(false);
			}
		}
		fetchLivraisons();
	}, []);

	if (loading) {
		return <ApiLoading type="loading">Chargement des livraisons...</ApiLoading>;
	}

	if (errors && errors.general) {
		return <ApiLoading type="error">{errors.general[0]}</ApiLoading>;
	}

	const handleOpen = (livraisonId: number) => {
		setSelectedLivraisonId(livraisonId);
		setOpen(true);
	}

	return (
		<Section fullwidth>
			<DialogPreparerLivraison
				open={open}
				onClose={() => setOpen(false)}
				livraisonId={selectedLivraisonId}
				livraisonNote={livraisons.find((livraison) => livraison.id === selectedLivraisonId)?.notes ?? null}
			/>

			<div className="flex justify-between items-center gap-2 mb-6">
				<Title type="h2" className="mb-4">Suivi des livraisons</Title>
			</div>

			<AlertLivraisonMissing forAdmin={false} />

			<DataTable
				columns={[
					{ key: 'group_id', label: 'Groupe', hidden: true },
					{ key: 'date_livraison', label: 'Date de livraison', hidden: true },
					{ key: 'id', label: 'N° Livraison', sortable: true, render: (value) => `#${value}` },
					{ key: 'date_livraison_display', label: 'Date de livraison', },
					{ key: 'referent_nom', label: 'Référent', },
					{
						key: 'statut', label: 'Statut',
						render: (value) => <Badge bgColor={getColorStatutLivraison(value)}>{getStatutLivraison(value)}</Badge>,
						filterOptions: filtersStatutLivraison()
					},
					{ key: 'nb_paniers', label: 'Nb de panier' },
					{ key: 'poids_total', label: 'Poids Total'},
				]}
				data={livraisons}
				actions={[
					{ label: 'Détails', buttonVariant: "primary", onClick: (row) => handleOpen(row.id) },
				]}
				actionWidth='w-32'
			/>
		</Section>
	)
}